export const BASE_PATH = "/"
export const LOGIN_PATH = "/login";
export const HOME_PATH = "/home";
export const LEARN_PATH = "/learner";
export const FEED_PATH = "/feed";
export const PERFORMANCE_PATH = "/performance";
export const SURVEY_PATH = "/surveys";
export const VOUCHERS_PATH = "/vouchers"
export const APP_ROUTER_PATH = "/";
export const WEEKLY_CONTEST = "/home/weeklycontest";
export const LEADBOARD_HISTORY = "/home/weeklycontest/history";
export const LEAVE_PATH = "/leave";
export const CREAT_LEAVE_PATH = "/leave/createleave";
export const REWARDS_PATH = "/rewards";
export const SEND_REWARDS_PATH = "/rewards/sendrewards";
export const CONFIRMATION_REWARD_PATH = '/rewards/sendrewards/confirmationrewards';
export const ADMIN_PATH = "/admin";
export const ATTENDANCE_VIEWED_CARD_DATA = "/admin/attendanceViewedCard";
export const LEAVE_VIEWED_CARD_DATA = '/admin/leaveViewedCard';
export const ATTENDANCE_HISTORY_PATH = '/admin/attendanceViewedCard/attendanceHistory';
export const LEAVE_HISTORY_PATH = '/admin/leaveViewedCard/leaveHistory';
export const WEEKLY_OFF_PATH = '/admin/weekly-off';
export const AGREEMENT_PATH = '/admin/select-store/asset-group/agreement';
export const DOWNLOAD_AGREEMENT_PATH = '/admin/select-store/asset-group/agreement/download-agreement';
export const ASSET_GROUP_PATH = '/admin/select-store/asset-group'
export const ASSETS_REGISTER_PATH = '/admin/assets-register';
export const ASSET_SELECT_ITEM_PATH = '/admin/select-item';
export const ASSET_SELECT_STORE_PATH = '/admin/register-assets';
export const ASSET_TERMS_AND_CONDITIONS = '/admin/select-store/asset-group/select-item/register-assets/terms-conditions';
export const ASSETS_REGISTER_VERIFY_OTP_PATH = '/admin/select-store/asset-group/select-item/register-assets/registerAsset-verifyOtp';
export const ASSETS_REGISTER_DOWNLOAD_QR_PATH = '/admin/select-store/asset-group/select-item/register-assets/registerAsset-verifyOtp/register-downloadQR';
export const ASSETS_REGISTER_REGISTERED_DOWNLOAD_PATH = '/admin/select-store/asset-group/select-item/register-assets/registerAsset-verifyOtp/registered-download';
export const DOWNLOAD_QR_PAGE_PATH = '/admin/select-store/asset-group/download-qr';
export const DOWNLOAD_QR_MOGAL_PATH = '/admin/select-store/asset-group/download-qr-modal';
export const DE_REGISTERED_ASSET_PATH = '/admin/select-store/asset-group/de-registered-asset';
export const DE_REGISTER_ASSET_INFO_PATH = '/admin/select-store/asset-group/de-registered-asset/asset-info';
export const DE_REGISTER_ASSET_PATH = '/admin/select-store/asset-group/de-registered-asset/asset-info/de-register-asset';
export const DE_REGISTER_ASSET_VERIFY_OTP_PATH = '/admin/select-store/asset-group/de-registered-asset/asset-info/de-register-asset/verify-otp';
export const MY_CERTIFICATE_PATH = '/my-certificate';
export const CERTIFICATE_DOWNLOAD_PATH = '/my-certificate/certificate';
export const REGISTERED_ASSET_EFFECTIVE_DATE_PATH = '/admin/select-store/asset-group/registered-asset';
export const EMPLOYEE_HELPDESK_PATH = '/employee-helpdesk';
export const RAISE_REQUEST_PATH = '/employee-helpdesk/raiserequest';
export const EMPLOYEE_HELPDESK_COMMENTS = '/employee-helpdesk/helpdesk-comments/'
export const EMPLOYEE_HELPDESK_VIEW_IMAGES = '/employee-helpdesk/helpdesk-comments/view-images'
export const CHECKLIST_PLANNER_PATH = '/admin/checklist-planner';
export const CHECKLIST_SELECT_STORE_PATH = '/admin/checklist-planner/select-store';
export const SELECT_CHECKLIST_PATH = '/admin/checklist-planner/select-store/select-checklist';
export const CHECKLIST_ADD_SCHEDULE_PATH = '/admin/checklist-planner/select-store/select-checklist/add-shcedule';
export const CHECKLIST_EDIT_SCHEDULE_PATH = '/admin/checklist-planner/edit-schedule';
export const CHECKLIST_RESCHEDULE_HISTORY = '/admin/checklist-planner/edit-schedule/reschedule-history';
export const REWARDS_HISTORY_PATH = "/rewards/rewardshistory";